import { render, staticRenderFns } from "./v.vue?vue&type=template&id=db5b1974&"
import script from "./v.vue?vue&type=script&lang=js&"
export * from "./v.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports